import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'Umrah & Hajj', path: '/umrah-hajj' },
    { name: 'Destinations', path: '/destinations' },
    { name: 'Travel Guides', path: '/travel-guides' },
    { name: 'Contact', path: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.querySelector(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const navigateToPage = (path: string) => {
    window.REACT_APP_NAVIGATE(path);
    setIsMobileMenuOpen(false);
  };

  const linkClass = `text-base font-medium transition-colors ${
    isScrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-white hover:text-[#14B8A6]'
  }`;

  return (
    <>
      <nav
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex items-center justify-between h-20">
            <div
              onClick={() => navigateToPage('/')}
              className="text-2xl font-bold cursor-pointer"
              style={{ fontFamily: 'Playfair Display, serif' }}
            >
              <span className={isScrolled ? 'text-[#1A1F2E]' : 'text-white'}>Alwaz Travel</span>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              <a href="/" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Home</a>
              <a href="/umrah-hajj" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Umrah & Hajj</a>
              <a href="/air-tickets-deals" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Flights</a>
              <a href="/family-holidays-destinations" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Family Holidays</a>
              <a href="/visit-london" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Visit London</a>
              <a href="/saudi-relocation" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Saudi Relocation</a>
              <a href="/travel-guides" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Travel Guides</a>
              <a href="/contact" className={`${linkClass} whitespace-nowrap cursor-pointer`}>Contact</a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden text-2xl cursor-pointer ${
                isScrolled ? 'text-[#1A1F2E]' : 'text-white'
              }`}
            >
              <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div
        className={`fixed inset-0 bg-black/50 z-40 lg:hidden transition-opacity duration-300 ${
          isMobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      ></div>

      <div
        className={`fixed top-0 right-0 h-full w-80 bg-white z-50 lg:hidden transform transition-transform duration-300 ${
          isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <nav className="flex flex-col space-y-1 p-6">
          <a
            href="/"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Home
          </a>
          <a
            href="/umrah-hajj"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Umrah & Hajj
          </a>
          <a
            href="/air-tickets-deals"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Flights
          </a>
          <a
            href="/family-holidays-destinations"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Family Holidays
          </a>
          <a
            href="/visit-london"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Visit London
          </a>
          <a
            href="/saudi-relocation"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Saudi Relocation
          </a>
          <a
            href="/travel-guides"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Travel Guides
          </a>
          <a
            href="/contact"
            className="px-4 py-3 text-gray-700 hover:bg-gray-50 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            Contact
          </a>
        </nav>
      </div>
    </>
  );
}